import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useCallback } from 'react';

var useRefresh = function useRefresh() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    setState = _useState2[1];
  return useCallback(function () {
    return setState(function (prev) {
      return !prev;
    });
  }, []);
};

export default useRefresh;
//# sourceMappingURL=use-refresh.esm.js.map
